// programs.ts — Endpoints programmes (groupements de projets).
import { req } from './_internals.js';

export const programsApi = {
  getPrograms: () => req('GET', '/programs'),
  createProgram: (d: unknown) => req('POST', '/programs', d),
  updateProgram: (id: number | string, d: unknown) => req('PUT', '/programs/' + id, d),
  deleteProgram: (id: number | string) => req('DELETE', '/programs/' + id),
};
